import { PatientStateType } from "@/api/dtos";


export const allStates: PatientStateType[] = [
    PatientStateType.Baseline,
    PatientStateType.Cycle2,
    PatientStateType.Cycle3,
    PatientStateType.EndOfTreatment,
    PatientStateType.Ineligible,
    PatientStateType.Withdrawn
];